import { render } from "./Thread.vue?vue&type=template&id=dbc5529e"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"

import "./Thread.vue?vue&type=style&index=0&id=dbc5529e&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__